module.exports = __webpack_public_path__ + "media/Video 93b.1aa9c4f2.mp4";